import React, { useContext, useEffect } from "react";
import { PageContext, PageState, PageAction } from "../../../lib/PageProvider";
import { UcWidget } from "../../common/UcWidget";
import { useTranslation } from "react-i18next";
import { Alert } from "@mui/material";
import { UcLoading } from "../../common/UcLoading";
import { useAutoPay } from "../../widgets/PaymentusApiEndpoints";
import EnsureUserAndModule from "../../auth/EnsureUserAndModule";
import './PaymentusPages.scss';

export const PaymentusAutoPayPage = () => {
    const { t } = useTranslation();
    const [pageState, pageDispatch] = useContext<[PageState, React.Dispatch<PageAction>]>(PageContext);
    const swrPaymentusUrl = useAutoPay();
    let isLoading = true;

    if ((swrPaymentusUrl && swrPaymentusUrl?.isLoading)) {
        isLoading = true;
    }
    else {
        isLoading = false;
    }

    useEffect(() => {
        pageDispatch({
            header: t("Paymentus AutoPay"),
            actionItems: [] as any[],
            variableHeader: "",
            tabs: [],
            onTabChange: () => {},
            tabValue: "",
        });
    }, [pageState.header, pageDispatch, t]);

    console.log("PaymentusAutoPayPage - Loaded");

    return (
        <EnsureUserAndModule modules={['Billing', 'PaymentusAutoPay']}>
            <UcWidget contentPadding="0" titleRender={false}>
                <UcLoading isLoading={isLoading} hasFade={false}>
                    {swrPaymentusUrl ?
                        <div className="paymentusAutoPay">
                            <iframe
                                title="PaymentusAutoPay"
                                allow="payment"
                                src={swrPaymentusUrl?.result}
                                className="paymentus-responsive-iframe"
                                style={{ border: "0px" }}
                            />
                        </div>
                        :
                        <Alert severity="warning">{t("Could not load Paymentus autopay.")}</Alert>
                    }
                </UcLoading>
            </UcWidget>  
        </EnsureUserAndModule>
            
    );
};
